import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {IApplication, IInterview, INote} from '../../../../../assets/types/dtoTypes';

@Injectable( {
  providedIn: 'root',
} )
export class ApplicationOverviewPageService {
  private http = inject(HttpClient);

  private applicationsUrl = `${environment.apiUrl}/job-applications`;

  private interviewsUrl = `${environment.apiUrl}/interviews`;

  private notesUrl = `${environment.apiUrl}/notes/application`;

  private updateNotesUrl = `${environment.apiUrl}/notes`;


  constructor() {}

  getApplication( applicationId: string ): Observable<IApplication> {
    const url = `${this.applicationsUrl}/${applicationId}`;
    return this.http.get<IApplication>( url );
  }

  addNote(applicationId: string, note: INote ) {
    const url = `${this.notesUrl}/${applicationId}`;
    return this.http.post<INote>( url, note );
  }

  getNotes(applicationId: string,): Observable<INote[]>  {
    const url = `${this.notesUrl}/${applicationId}`;
    return this.http.get<INote[]>( url );
  }

  updateNote(noteId: string, updatedNote: INote) {
    const url = `${this.updateNotesUrl}/${noteId}`;
    return this.http.put<INote>(url, updatedNote);
  }

  deleteNote(noteId: string) {
    const url = `${this.updateNotesUrl}/${noteId}`;
    return this.http.delete(url);
  }

  getInterviewsByApplication(applicationId: string): Observable<IInterview[]> {
    const url = `${this.interviewsUrl}/job-application/${applicationId}`;
    return this.http.get<IInterview[]>(url);
  }

  cancelInterview(interviewId: string): Observable<void> {
    const url = `${this.interviewsUrl}/${interviewId}/cancel`;
    return this.http.post<void>(url, {});
  }

  confirmReschedule(interviewId: string): Observable<IInterview> {
    return this.http.post<IInterview>(`${this.interviewsUrl}/${interviewId}/confirm-reschedule`, {});
  }

  declineReschedule(interviewId: string): Observable<void> {
    return this.http.post<void>(`${this.interviewsUrl}/${interviewId}/cancel`, {});
  }


}
